<template>
  <div>
    <meta
      v-if="pageUrl"
      itemscope
      itemprop="mainEntityOfPage"
      itemType="https://schema.org/WebPage"
      :itemid="pageUrl"
    />
    <div class="match-info-head-wrap">
      <h1 class="head-title" itemprop="headline" v-if="pageHeadline">
        {{ pageHeadline }}
      </h1>
      <div class="meta-wrap" v-if="article_mt_content">
        <span class="meta-date meta">{{ last_updated_label }}{{ article_mt_content }}</span>
        <a v-if="isArticleAvailable" :href="article_button_details.link" class="lng-trans">{{ article_button_details.label }}</a>
        <google-news />
      </div>
    </div>
    <meta
      v-if="article_mt_meta"
      itemprop="dateModified"
      :content="article_mt_meta"
    />
    <meta
      v-if="article_pt_meta"
      itemprop="datePublished"
      :content="article_pt_meta"
    />
    <span itemscope itemprop="author" itemtype="https://schema.org/Thing">
      <meta itemprop="name" content="Fantasy Gully" />
      <meta itemprop="url" content="https://www.youtube.com/c/FantasyGully" />
    </span>
    <div
      itemprop="publisher"
      itemscope
      itemtype="https://schema.org/Organization"
    >
      <div
        style="display: none"
        itemprop="logo"
        itemscope
        itemtype="https://schema.org/ImageObject"
      >
        <img
          src="https://www.fantasygully.com/static-assets/images/cssimages/logo.png"
          alt=""
        />
        <meta
          itemprop="url"
          content="https://www.fantasygully.com/static-assets/images/cssimages/logo.png"
        />
        <meta itemprop="width" content="156" />
        <meta itemprop="height" content="42" />
      </div>
      <meta itemprop="name" content="Fantasy Gully Private Limited" />
    </div>
  </div>
</template>

<script>
import GoogleNews from "../../common/googleNews";
export default {
  props: [ "last_updated_label", "isArticleAvailable", "article_button_details", "pageUrl", "pageHeadline", "article_mt_content", "article_mt_meta", "article_pt_meta" ],
  components: {
    GoogleNews
  }
};
</script>